"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5547],{

/***/ 72527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Callout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52494);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45001);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33772);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75426);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79771);



function Callout(param) {
    let { type , body  } = param;
    const secondaryBlue = "primary.500";
    const iconSwitch = ()=>{
        switch(type){
            case "Danger":
                return {
                    icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                    color: "red.500"
                };
            case "Warning":
                return {
                    icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                    color: "yellow.500"
                };
            case "Success":
                return {
                    icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                    color: "green.500"
                };
            case "Info":
                return {
                    icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                    color: secondaryBlue
                };
            default:
                return {
                    icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                    color: secondaryBlue
                };
        }
    };
    const borderSwitch = ()=>{
        switch(type){
            case "Danger":
                return {
                    color: "red.500"
                };
            case "Warning":
                return {
                    color: "yellow.500"
                };
            case "Success":
                return {
                    color: "green.500"
                };
            case "Info":
                return {
                    color: secondaryBlue
                };
            default:
                return {
                    color: secondaryBlue
                };
        }
    };
    const { icon , color: iconColor  } = iconSwitch();
    const { color: borderColor  } = borderSwitch();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
        justify: "center",
        align: "center",
        px: 6,
        py: 4,
        my: 6,
        bg: "background",
        gap: 2,
        rounded: "md",
        borderLeft: "solid 4px",
        borderColor: borderColor,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                as: icon,
                color: iconColor,
                boxSize: 5,
                pos: "relative"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                w: "full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                    color: "white",
                    children: body
                })
            })
        ]
    });
}


/***/ }),

/***/ 38023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MDX; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var markdown_to_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86243);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clerk_nextjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16855);
/* harmony import */ var _clerk_nextjs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_clerk_nextjs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_sanity_serializers_code__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10814);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36696);
/* harmony import */ var _callout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72408);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var prism_react_renderer_themes_oceanicNext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2097);










const CodeBlock = (param)=>{
    let { className , children  } = param;
    let lang = "text";
    if (className && className.startsWith("lang-")) {
        lang = className.replace("lang-", "");
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sanity_serializers_code__WEBPACK_IMPORTED_MODULE_3__/* .Code */ .E, {
        theme: prism_react_renderer_themes_oceanicNext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
        language: lang,
        withCopy: true,
        withLineNumbers: true,
        children: children
    });
};
// markdown-to-jsx uses <pre><code/></pre> for code blocks.
const PreBlock = (param)=>{
    let { children , ...rest } = param;
    if ("type" in children && children["type"] === "code") {
        return CodeBlock(children["props"]);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
        ...rest,
        children: children
    });
};
function MDX(param) {
    let { content  } = param;
    const [loaded, setLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(()=>{
        if (content) {
            setLoaded(true);
        }
    }, []);
    if (loaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(markdown_to_jsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            options: {
                overrides: {
                    SignIn: {
                        component: _clerk_nextjs__WEBPACK_IMPORTED_MODULE_8__.SignIn
                    },
                    SignUp: {
                        component: _clerk_nextjs__WEBPACK_IMPORTED_MODULE_8__.SignUp
                    },
                    UserButton: {
                        component: _clerk_nextjs__WEBPACK_IMPORTED_MODULE_8__.UserButton
                    },
                    UserProfile: {
                        component: _clerk_nextjs__WEBPACK_IMPORTED_MODULE_8__.UserProfile
                    },
                    Callout (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_callout__WEBPACK_IMPORTED_MODULE_4__/* .Callout */ .U, {
                            body: children,
                            type: props.type,
                            ...props
                        });
                    },
                    button (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                            as: "button",
                            onClick: ()=>{
                                return eval(props === null || props === void 0 ? void 0 : props.onclick);
                            },
                            ...props,
                            children: children
                        });
                    },
                    pre: PreBlock,
                    a (param) {
                        let { children , href  } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: href,
                            children: children
                        });
                    },
                    h1 (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X6, {
                            ...props,
                            as: "h1",
                            fontSize: "48px",
                            pt: "24px",
                            pb: "12px",
                            children: children
                        });
                    },
                    h2 (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X6, {
                            ...props,
                            as: "h2",
                            fontSize: "36px",
                            pt: "24px",
                            pb: "12px",
                            children: children
                        });
                    },
                    h3 (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X6, {
                            ...props,
                            as: "h3",
                            fontSize: "24px",
                            pt: "24px",
                            pb: "12px",
                            children: children
                        });
                    },
                    h4 (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X6, {
                            ...props,
                            as: "h4",
                            fontSize: "16px",
                            py: "12px",
                            children: children
                        });
                    },
                    h5 (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X6, {
                            ...props,
                            as: "h5",
                            fontSize: "12px",
                            py: "12px",
                            children: children
                        });
                    },
                    h6 (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Heading */ .X6, {
                            ...props,
                            as: "h6",
                            fontSize: "8px",
                            py: "12px",
                            children: children
                        });
                    },
                    table: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Table */ .iA,
                    tbody: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Tbody */ .p3,
                    thead: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Thead */ .hr,
                    tfoot: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Tfoot */ .$R,
                    th: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__.Th,
                    tr: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__.Tr,
                    td: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__.Td,
                    p (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .xv, {
                            as: "p",
                            ...props,
                            py: "12px",
                            children: children
                        });
                    },
                    div (param) {
                        let { children , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            as: "div",
                            ...props,
                            children: children
                        });
                    },
                    ul: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .UnorderedList */ .QI,
                    ol: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .OrderedList */ .GS,
                    li: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ListItem */ .HC,
                    blockquote (param) {
                        let { children  } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .xv, {
                            bg: "#f9f9f9",
                            borderLeft: "10px solid #ccc",
                            margin: "1.5em 10px",
                            padding: "0.5em 10px",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                                ml: "12px",
                                children: children
                            })
                        });
                    },
                    img (param) {
                        let { ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            w: "100%",
                            py: "12px",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                alt: props.alt,
                                src: props.src,
                                width: 1000,
                                height: 500
                            })
                        });
                    }
                }
            },
            children: content
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
}


/***/ }),

/***/ 35547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ SaneBlockChakra; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(88863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/index.esm.js
var react_youtube_dist_index_esm = __webpack_require__(5406);
// EXTERNAL MODULE: ./node_modules/get-youtube-id/index.js
var get_youtube_id = __webpack_require__(6998);
var get_youtube_id_default = /*#__PURE__*/__webpack_require__.n(get_youtube_id);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/LinkIcon.js
var LinkIcon = __webpack_require__(77082);
// EXTERNAL MODULE: ./utils/normalize-string.ts
var normalize_string = __webpack_require__(35182);
;// CONCATENATED MODULE: ./components/common/icons/external-link.js

function ExternalLinkIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        display: "inline-block",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.8203 3C11.268 3 10.8203 3.44772 10.8203 4C10.8203 4.55228 11.268 5 11.8203 5H14.4061L8.11321 11.2929C7.72268 11.6834 7.72268 12.3166 8.11321 12.7071C8.50373 13.0976 9.1369 13.0976 9.52742 12.7071L15.8203 6.41421V9C15.8203 9.55228 16.268 10 16.8203 10C17.3726 10 17.8203 9.55228 17.8203 9V4C17.8203 3.44772 17.3726 3 16.8203 3H11.8203Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.82031 5C4.71574 5 3.82031 5.89543 3.82031 7V15C3.82031 16.1046 4.71574 17 5.82031 17H13.8203C14.9249 17 15.8203 16.1046 15.8203 15V12C15.8203 11.4477 15.3726 11 14.8203 11C14.268 11 13.8203 11.4477 13.8203 12V15H5.82031V7L8.82031 7C9.3726 7 9.82031 6.55228 9.82031 6C9.82031 5.44772 9.3726 5 8.82031 5H5.82031Z",
                fill: "currentColor"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/sanity/sane-image.tsx
var sane_image = __webpack_require__(27013);
;// CONCATENATED MODULE: ./components/sanity/serializers/attribution.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck


function Attribution(param) {
    let { authors  } = param;
    const nameList = authors.map((x)=>x.name);
    const names = new Intl.ListFormat("en").format(nameList);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-t border-gray-200 border-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 text-base font-semibold text-gray-700",
                children: "Thanks to the contributors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap mt-1",
                children: names
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap mt-4 mb-10 sm:w-full",
                children: authors.map((author)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row mb-3 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-shrink-0 mr-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: author.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                                    className: "block w-10 h-10 rounded-md",
                                    src: author.picture,
                                    height: 48,
                                    width: 48,
                                    quality: 100,
                                    display: "fixed"
                                })
                            ]
                        })
                    }, author.name);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ExclamationCircleIcon.js
var ExclamationCircleIcon = __webpack_require__(45001);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ExclamationIcon.js
var ExclamationIcon = __webpack_require__(33772);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/CheckCircleIcon.js
var CheckCircleIcon = __webpack_require__(75426);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/InformationCircleIcon.js
var InformationCircleIcon = __webpack_require__(79771);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/sanity/serializers/callout.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck







const serializers = {
    types: {
        block: (param)=>{
            let { children  } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                textStyle: "sm-normal",
                children: children
            });
        }
    },
    marks: {
        fragmentId: (param)=>{
            let { mark , children  } = param;
            const { hash  } = mark;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                id: hash,
                children: children
            });
        },
        internalLink: (param)=>{
            let { mark , children  } = param;
            const { hash , slug ={}  } = mark;
            const href = slug === null || slug === void 0 ? void 0 : slug.current;
            if (hash) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(href || "", "#").concat(hash),
                    children: children
                });
            }
            if (href) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    legacyBehavior: true,
                    href: href,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                        fontWeight: "medium",
                        children: children
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            });
        },
        link: (param)=>{
            let { mark , children  } = param;
            const { blank , href  } = mark;
            if (href) {
                return blank ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Link */.rU, {
                    href: href,
                    isExternal: true,
                    fontWeight: "medium",
                    children: [
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                            as: ExternalLinkIcon,
                            pos: "relative",
                            top: -0.5,
                            ml: 0.5,
                            boxSize: 5
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                    href: href,
                    fontWeight: "medium",
                    children: children
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            });
        }
    }
};
function Callout(param) {
    let { type , body  } = param;
    const { route  } = (0,router.useRouter)();
    const secondaryBlue = route.includes("/docs/") ? "var(--secondaryBlue)" : "primary.500";
    const backgroundColor = route.includes("/docs/") ? "var(--highlightBg)" : "gray.50";
    const iconSwitch = ()=>{
        switch(type){
            case "Danger":
                return {
                    icon: ExclamationCircleIcon/* default */.Z,
                    color: "red.500"
                };
            case "Warning":
                return {
                    icon: ExclamationIcon/* default */.Z,
                    color: "yellow.500"
                };
            case "Success":
                return {
                    icon: CheckCircleIcon/* default */.Z,
                    color: "green.500"
                };
            case "Info":
                return {
                    icon: InformationCircleIcon/* default */.Z,
                    color: secondaryBlue
                };
            default:
                return {
                    icon: InformationCircleIcon/* default */.Z,
                    color: secondaryBlue
                };
        }
    };
    const borderSwitch = ()=>{
        switch(type){
            case "Danger":
                return {
                    color: "red.500"
                };
            case "Warning":
                return {
                    color: "yellow.500"
                };
            case "Success":
                return {
                    color: "green.500"
                };
            case "Info":
                return {
                    color: secondaryBlue
                };
            default:
                return {
                    color: secondaryBlue
                };
        }
    };
    const { icon , color: iconColor  } = iconSwitch();
    const { color: borderColor  } = borderSwitch();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        justify: "center",
        align: "center",
        px: 6,
        py: 4,
        my: 6,
        bg: backgroundColor,
        gap: 2,
        rounded: "md",
        borderLeft: "solid 4px",
        borderColor: borderColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                as: icon,
                color: iconColor,
                boxSize: 5,
                pos: "relative"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                w: "full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                    blocks: body,
                    serializers: serializers
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/sanity/serializers/code.tsx + 1 modules
var code = __webpack_require__(10814);
// EXTERNAL MODULE: ./node_modules/prism-react-renderer/themes/github/index.js
var github = __webpack_require__(7694);
;// CONCATENATED MODULE: ./components/sanity/serializers/code-snippet.tsx




function CodeSnippet(param) {
    let { body , theme , withCopy , withLineNumbers  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative my-4 not-prose",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code/* Code */.E, {
            filename: body.filename,
            theme: theme === "light" ? github/* default */.Z : theme,
            language: body.language,
            highlightedLines: body.highlightedLines,
            withLineNumbers: withLineNumbers,
            withCopy: withCopy,
            children: body.code
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/app-and-instance-switcher.tsx
var app_and_instance_switcher = __webpack_require__(93376);
;// CONCATENATED MODULE: ./hooks/use-dynamic-api-keys.ts


const TEMPLATES = {
    PUB_KEY: "{{pub_key}}",
    SECRET_KEY: "{{secret}}"
};
const PROD_HIDDEN = "sk_live_••••••••••••••••••••••••••••••••••";
const DEV_HIDDEN = "sk_test_••••••••••••••••••••••••••••••••••";
function useDynamicApiKeys(code) {
    const { currentInstance  } = react.useContext(app_and_instance_switcher/* AppAndInstanceSwitcherContext */.X);
    const [codeWithVisibleKeys, setCodeWithVisibleKeys] = react.useState("");
    const [codeWithHiddenKeys, setCodeWithHiddenKeys] = react.useState("");
    const secretHidden = (currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.environment_type) === "production" ? PROD_HIDDEN : DEV_HIDDEN;
    const hasTemplate = code.includes(TEMPLATES.PUB_KEY) || code.includes(TEMPLATES.SECRET_KEY);
    const pubKeyRegex = new RegExp("".concat(TEMPLATES.PUB_KEY), "g");
    const secretRegex = new RegExp("".concat(TEMPLATES.SECRET_KEY), "g");
    react.useEffect(()=>{
        const pubKey = (currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.publishable_key) || "your_publishable_key";
        const secretKey = (currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.secret_key) || "your_secret_key";
        setCodeWithVisibleKeys(code.replace(pubKeyRegex, pubKey).replace(secretRegex, secretKey));
        setCodeWithHiddenKeys(code.replace(pubKeyRegex, pubKey).replace(secretRegex, secretHidden));
        [
            code,
            hasTemplate,
            currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.publishable_key
        ];
    });
    return {
        showKeysVisibilityToggle: Boolean(currentInstance && code.includes(TEMPLATES.SECRET_KEY)),
        codeWithVisibleKeys,
        codeWithHiddenKeys
    };
}

// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js + 55 modules
var tooltip_dist_index_esm = __webpack_require__(43489);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/EyeOffIcon.js
var EyeOffIcon = __webpack_require__(77481);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/EyeIcon.js
var EyeIcon = __webpack_require__(71738);
;// CONCATENATED MODULE: ./components/common/toggle-keys-visibility.tsx



function ToggleKeysVisibility(param) {
    let { showKeys , setShowKeys  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
        label: showKeys ? "Hide sensitive keys" : "Show all keys",
        "aria-label": showKeys ? "Hide sensitive keys" : "Show all keys",
        closeOnClick: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
            as: "button",
            onClick: ()=>setShowKeys(!showKeys),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                as: showKeys ? EyeOffIcon/* default */.Z : EyeIcon/* default */.Z,
                boxSize: 5
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/sanity/serializers/env-snippet.tsx







function EnvSnippet(param) {
    let { body , theme , withCopy , withLineNumbers  } = param;
    const { showKeysVisibilityToggle , codeWithVisibleKeys , codeWithHiddenKeys  } = useDynamicApiKeys(body.code);
    const [showKeys, setShowKeys] = react.useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        my: 4,
        pos: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code/* Code */.E, {
            filename: body.filename || ".env",
            theme: theme === "light" ? github/* default */.Z : theme,
            language: body.language,
            highlightedLines: body.highlightedLines,
            withLineNumbers: withLineNumbers,
            withCopy: withCopy,
            showKeysVisibilityToggle: showKeysVisibilityToggle,
            codeWithVisibleKeysFormatted: codeWithVisibleKeys,
            toggleComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleKeysVisibility, {
                showKeys: showKeys,
                setShowKeys: setShowKeys
            }),
            children: showKeysVisibilityToggle ? showKeys ? codeWithVisibleKeys : codeWithHiddenKeys : codeWithVisibleKeys
        })
    });
}

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/sanity.js + 3 modules
var sanity = __webpack_require__(53822);
;// CONCATENATED MODULE: ./components/common/icons/browser-frame.js

function BrowserFrame() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1046.688 32",
        style: {
            borderRadius: "8px 8px 0 0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "100%",
                height: "32px",
                fill: "#e8e8e8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "16",
                r: "4",
                fill: "#C0C8D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "36",
                cy: "16",
                r: "4",
                fill: "#C0C8D3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "52",
                cy: "16",
                r: "4",
                fill: "#C0C8D3"
            })
        ]
    });
}
/* harmony default export */ var browser_frame = ((/* unused pure expression or super */ null && (BrowserFrame)));

;// CONCATENATED MODULE: ./components/sanity/serializers/image.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck




function Image(param) {
    let { node  } = param;
    const widthClass = node.width ? "w-[" + node.width + "px]" : undefined;
    const browserClass = "drop-shadow-lg overflow-hidden max-h-[600px]";
    if (node.type === "Browser") {
        const url = (0,sanity/* urlForImage */.iQ)(node.asset).url();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
            className: classnames_default()("m-auto text-center my-12", widthClass, browserClass),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserFrame, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "not-prose",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: node.alt,
                        src: url
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: classnames_default()("m-auto text-center", widthClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                src: node,
                width: node.width,
                wrapClassName: node.width ? "image-wrap m-auto" : undefined
            }),
            node.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                children: node.caption
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/sanity/components/mdx.tsx
var mdx = __webpack_require__(38023);
;// CONCATENATED MODULE: ./components/sanity/serializers/mdx.tsx


function Markdown(param) {
    let { node  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(mdx/* MDX */.M, {
        content: node.markdown,
        _node: true
    });
}

;// CONCATENATED MODULE: ./components/sanity/serializers/table-style.ts
const tableStyle = {
    table: {
        boxShadow: "lg",
        mx: "auto",
        my: 3,
        overflow: "hidden",
        rounded: "xl"
    },
    thead: {
        bg: "var(--tableHead)"
    },
    th: {
        borderRight: "1px solid",
        color: "var(--primaryTextColor)"
    },
    tbody: {
        border: "none",
        bg: "var(--tableBody)"
    },
    "tr, td, th": {
        borderColor: "#00000014 !important",
        "&:last-child": {
            borderRight: "none"
        }
    },
    td: {
        color: "var(--primaryTextColor)"
    },
    "td .text-gray-700": {
        color: "var(--secondaryTextColor)"
    }
};

;// CONCATENATED MODULE: ./components/sanity/serializers/props-table.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck






const types = {
    block: (props)=>{
        return BlockContent_default().defaultSerializers.types.block(props);
    }
};
const marks = {
    fragmentId: (param)=>{
        let { mark , children  } = param;
        const { hash  } = mark;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            id: hash,
            children: children
        });
    },
    internalLink: (param)=>{
        let { mark , children  } = param;
        const { hash , slug ={}  } = mark;
        const href = slug === null || slug === void 0 ? void 0 : slug.current;
        if (hash) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "".concat(href || "", "#").concat(hash),
                children: children
            });
        }
        if (href) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "font-normal",
                    children: children
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: children
        });
    },
    link: (param)=>{
        let { mark , children  } = param;
        const { blank , href  } = mark;
        if (href) {
            return blank ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: href,
                target: "_blank",
                rel: "noopener",
                className: "font-normal",
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLinkIcon, {
                        className: "relative inline-block ml-1 top-[-2px]"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                className: "font-normal",
                children: children
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: children
        });
    }
};
const props_table_serializers = {
    types,
    marks
};
function PropsTable(param) {
    let { props  } = param;
    const hasName = props.some((prop)=>prop.name);
    const hasType = props.some((prop)=>prop.type);
    const hasDescription = props.some((prop)=>prop.description);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        className: "flex flex-col",
        sx: {
            "&": tableStyle
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "inline-block max-w-full py-2 overflow-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "divide-y divide-gray-300 shadow ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        className: "bg-gray-50",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                hasName && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "py-2 !px-4 text-sm font-semibold text-gray-900 w-1/4",
                                    children: "Name"
                                }),
                                hasType && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "py-2 !px-4 text-sm font-semibold text-gray-900 w-1/4",
                                    children: "Type"
                                }),
                                hasDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "py-2 !px-4 text-sm font-semibold text-gray-900 w-1/2",
                                    children: "Description"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        className: "bg-white divide-y divide-gray-200 ",
                        children: props.map((prop, index)=>{
                            const { description  } = prop;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    hasName && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 !px-4 font-medium text-sm text-gray-900 border-r w-1/4 ",
                                        children: prop.name
                                    }),
                                    hasType && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 !px-4 italic text-gray-700 border-r w-1/4",
                                        children: prop.type
                                    }),
                                    hasDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 !px-4 text-sm font-base text-gray-800 border-r w-1/2 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
                                            blocks: description,
                                            serializers: props_table_serializers
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/sanity/serializers/table.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck

function Table(param) {
    let { rows  } = param;
    const headings = rows[0].cells;
    const rowData = rows.slice(1).map((e)=>e);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-2 overflow-x-scroll 2xl:overflow-x-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inline-block py-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: "divide-y divide-gray-300 shadow ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            className: "bg-gray-50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: headings === null || headings === void 0 ? void 0 : headings.map((heading, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "col",
                                        className: "py-2 !px-4 text-sm font-semibold text-gray-900 ",
                                        children: heading
                                    }, "th-".concat(index)))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            className: "bg-white divide-y divide-gray-200 ",
                            children: rowData.map((row, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                    children: row.cells.map((cell, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "!p-2 font-mono text-sm font-medium text-gray-900 border-r min-w-full ",
                                            children: cell
                                        }, "cell-".concat(index, "-").concat(idx)))
                                }, "row-".concat(index)))
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 3 modules
var system_dist_index_esm = __webpack_require__(83961);
;// CONCATENATED MODULE: ./components/sanity/serializers/tabs.tsx






const { toKebabCase  } = normalize_string/* normalizeString */.U;
function Tab(param) {
    let { title , body , isActive  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        display: isActive ? "block" : "none",
        pos: "relative",
        id: toKebabCase(title),
        role: "tabpanel",
        "aria-labelledby": "tab-".concat(toKebabCase(title)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code/* Code */.E, {
            withTabs: true,
            theme: github/* default */.Z,
            language: body.language,
            highlightedLines: body.highlightedLines,
            withLineNumbers: true,
            withCopy: true,
            children: body.code
        })
    });
}
function Tabs(param) {
    let { tabs  } = param;
    const [activeTab, setActiveTab] = react.useState(tabs[0].title);
    const activeBg = "#282C34";
    const inactiveBg = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.100", "#18191C");
    const hoverBg = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.50", "#111214");
    const activeColor = "white";
    const inactiveColor = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("gray.800", "gray.300");
    const borderColor = (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("rgba(0,0,0,0.1)", "rgba(255,255,255,0.05)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        py: 4,
        mx: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* UnorderedList */.QI, {
                role: "tablist",
                display: "flex",
                flexWrap: "wrap",
                listStyleType: "none",
                m: 0,
                children: tabs.map((param, index)=>{
                    let { _key , title  } = param;
                    const isActive = title === activeTab;
                    const isFirst = index === 0;
                    const isLast = index === tabs.length - 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        role: "presentation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.button */.m$.button, {
                            id: "tab-".concat(toKebabCase(title)),
                            type: "button",
                            role: "tab",
                            py: 2,
                            px: 4,
                            bg: isActive ? activeBg : inactiveBg,
                            borderTopLeftRadius: isFirst ? "md" : "0",
                            borderTopRightRadius: isLast ? "md" : "0",
                            color: isActive ? activeColor : inactiveColor,
                            borderLeft: isFirst ? "1px solid" : "none",
                            borderRight: "1px solid",
                            borderTop: "1px solid",
                            borderColor: borderColor,
                            pointerEvents: isActive ? "none" : "auto",
                            textStyle: "sm-medium",
                            "aria-controls": toKebabCase(title),
                            "aria-selected": activeTab === title ? "true" : "false",
                            onClick: setActiveTab.bind(null, title),
                            transition: "background 0.2s",
                            _hover: {
                                bg: !isActive && hoverBg
                            },
                            children: title
                        })
                    }, _key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: tabs.map((param)=>{
                    let { _key , title , body  } = param;
                    const isActive = title === activeTab;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                        title: title,
                        body: body,
                        isActive: isActive
                    }, _key);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/sanity/serializers/serializers.tsx
// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck




















const { toKebabCase: serializers_toKebabCase  } = normalize_string/* normalizeString */.U;
const serializers_types = {
    block: (props)=>{
        const { node , children  } = props;
        const { style  } = node;
        if (/^h\d/.test(style)) {
            const HeadingTag = style;
            // Create ID based off heading text content
            // Sometimes there is a nested <span> inside
            const headingId = typeof children[0] === "string" ? serializers_toKebabCase(children[0]) : serializers_toKebabCase(children[0].props.node.children[0]);
            const size = HeadingTag === "h2" ? "h5" : "h6";
            const marginY = HeadingTag === "h2" ? 8 : 6;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                as: HeadingTag,
                id: headingId,
                size: size,
                sx: {
                    marginTop: "-75px",
                    paddingTop: "calc(75px + var(--chakra-space-".concat(marginY, "))")
                },
                role: "group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#".concat(headingId),
                        "aria-hidden": "true",
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                            as: LinkIcon/* default */.Z,
                            boxSize: 4,
                            display: "none",
                            color: "gray.500",
                            ml: 2,
                            _groupHover: {
                                display: "inline-block"
                            }
                        })
                    })
                ]
            });
        }
        // Return default serializer
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            my: 4,
            lineHeight: 1.8,
            children: BlockContent_default().defaultSerializers.types.block(props)
        });
    },
    code: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(code/* Code */.E, {
            highlightedLines: props.node.highlightedLines,
            theme: "dark",
            children: props.node.code
        }),
    codeSnippet: (param)=>{
        let { node  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeSnippet, {
            body: node.codeBody,
            theme: node.theme,
            withCopy: node.copyButton,
            withLineNumbers: node.lineNumbers
        });
    },
    envSnippet: (param)=>{
        let { node  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvSnippet, {
            body: node.codeBody,
            theme: node.theme,
            withCopy: node.copyButton,
            withLineNumbers: node.lineNumbers
        });
    },
    image: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
            ...props,
            alt: props.node.alt
        }),
    html: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            dangerouslySetInnerHTML: {
                __html: props.node.code
            },
            sx: {
                "&": tableStyle
            }
        }),
    markdown: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown, {
            ...props
        }),
    attribution: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Attribution, {
            authors: props.node.authors
        }),
    callout: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Callout, {
            type: props.node.calloutType,
            body: props.node.body[0]
        }),
    table: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
            rows: props.node.rows
        }),
    tabs: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
            tabs: props.node.tabs
        }),
    youtube: (param)=>{
        let { node  } = param;
        const { url  } = node;
        const id = get_youtube_id_default()(url) || undefined;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
            ratio: 16 / 9,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_youtube_dist_index_esm/* default */.Z, {
                videoId: id
            })
        });
    },
    arcade: (param)=>{
        let { node  } = param;
        const { url  } = node;
        const demoUrl = url === null || url === void 0 ? void 0 : url.replace("app", "demo").replace("share/", "");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            position: "relative",
            paddingBottom: "calc(66.66666666666666% + 41px)",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "".concat(demoUrl, "?embed"),
                frameBorder: 0,
                loading: "lazy",
                webkitallowfullscreen: true,
                mozallowfullscreen: true,
                allowFullScreen: true,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%"
                }
            })
        });
    },
    propsTable: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PropsTable, {
            props: props.node.propsTable
        })
};
const list = (props)=>props.type === "bullet" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* UnorderedList */.QI, {
        children: props.children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* OrderedList */.GS, {
        children: props.children
    });
const listItem = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
        lineHeight: 1.8,
        children: props.children
    });
const serializers_marks = {
    code: (param)=>/*#__PURE__*/ {
        let { children  } = param;
        return (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            as: "code",
            fontFamily: "monospace, monospace",
            fontWeight: "medium",
            px: 1,
            children: children
        });
    },
    fragmentId: (param)=>{
        let { mark , children  } = param;
        const { hash  } = mark;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            id: hash,
            children: children
        });
    },
    internalLink: (param)=>{
        let { mark , children  } = param;
        const { hash , slug ={}  } = mark;
        const href = slug === null || slug === void 0 ? void 0 : slug.current;
        if (hash) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                href: "".concat(href || "", "#").concat(hash),
                fontWeight: "medium",
                children: children
            });
        }
        if (href) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                    fontWeight: "medium",
                    children: children
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: children
        });
    },
    link: (param)=>{
        let { mark , children  } = param;
        const { blank , href  } = mark;
        if (href) {
            return blank ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Link */.rU, {
                href: href,
                isExternal: true,
                fontWeight: "medium",
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                        as: ExternalLinkIcon,
                        pos: "relative",
                        top: -0.5,
                        ml: 0.5,
                        boxSize: 5
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                href: href,
                fontWeight: "medium",
                children: children
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: children
        });
    }
};
const serializers_serializers = {
    types: serializers_types,
    list,
    listItem,
    marks: serializers_marks
};

;// CONCATENATED MODULE: ./components/sanity/sane-block.tsx
// @ts-ignore



function SaneBlockChakra(param) {
    let { blocks  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        blocks: blocks,
        serializers: serializers_serializers
    });
}


/***/ }),

/***/ 27013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SaneImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53822);



function SaneImage(param) {
    let { src , height , width , layout , wrapClassName , ...props } = param;
    const { dimensions , format  } = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .decodeAssetId */ .h9)(src.asset._ref);
    const url = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .urlForImage */ .iQ)(src.asset).url() || "";
    const newHeight = height ? height : width ? width / dimensions.width * dimensions.height : format === "svg" || src.lowresolution ? dimensions.height : dimensions.height / 2;
    const newWidth = width ? width : height ? height / dimensions.height * dimensions.width : format === "svg" || src.lowresolution ? dimensions.width : dimensions.width / 2;
    const customDimensions = layout ? {
        layout
    } : {
        height: newHeight,
        width: newWidth
    };
    return format === "gif" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: url,
        height: newHeight,
        width: newWidth,
        alt: src.alt
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: wrapClassName || "image-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            alt: src.alt,
            ...props,
            ...customDimensions,
            src: url
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SaneImage);


/***/ }),

/***/ 10814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Code; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prism-react-renderer/dist/index.js + 2 modules
var dist = __webpack_require__(27087);
// EXTERNAL MODULE: ./node_modules/prism-react-renderer/themes/oceanicNext/index.js
var oceanicNext = __webpack_require__(2097);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js + 55 modules
var dist_index_esm = __webpack_require__(43489);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/DocumentDuplicateIcon.js
var DocumentDuplicateIcon = __webpack_require__(47078);
;// CONCATENATED MODULE: ./components/common/copy-button.tsx




function CopyButton(param) {
    let { copyText  } = param;
    const [copied, setCopied] = react.useState(false);
    const handleClick = ()=>{
        navigator.clipboard.writeText(copyText);
        setCopied(true);
    };
    react.useEffect(()=>{
        let timer;
        if (copied) {
            timer = setTimeout(()=>{
                setCopied(false);
            }, 1000);
        }
        return ()=>clearTimeout(timer);
    }, [
        copied,
        setCopied
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Tooltip */.u, {
        label: copied ? "Copied" : "Copy",
        "aria-label": "Copy to clipboard",
        closeOnClick: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
            as: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                as: DocumentDuplicateIcon/* default */.Z,
                boxSize: 5,
                onClick: handleClick
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/sanity/serializers/code.tsx







const WithLineNumbers = (param)=>/*#__PURE__*/ {
    let { children , index , lineProps  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        ...lineProps,
        className: classnames_default()(lineProps.className, "table-row"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "table-cell pr-3 text-right opacity-50 select-none",
                children: index + 1
            }),
            children
        ]
    }, "line".concat(index));
};
function Code(param) {
    let { className: userClassName , language ="jsx" , children , filename , theme , highlightedLines , codeWithVisibleKeysFormatted , withLineNumbers =false , withTabs =false , withCopy =false , showKeysVisibilityToggle =false , toggleComponent =null  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                align: "center",
                gap: 2,
                pos: "absolute",
                right: 0,
                top: 0,
                p: 4,
                roundedTopRight: "md",
                bg: "#282c34",
                color: "#fff",
                children: [
                    showKeysVisibilityToggle ? toggleComponent : null,
                    withCopy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                        copyText: typeof codeWithVisibleKeysFormatted === "string" ? codeWithVisibleKeysFormatted : children
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                ...dist/* defaultProps */.lG,
                theme: oceanicNext/* default */.Z,
                code: children,
                language: language,
                children: (param)=>/*#__PURE__*/ {
                    let { className , style , tokens , getLineProps , getTokenProps  } = param;
                    return (0,jsx_runtime.jsxs)("pre", {
                        className: classnames_default()(className, "leading-[1.8]", userClassName ? userClassName : "overflow-x-auto p-4 pr-12 m-6 mx-0 mt-8 bg-white rounded-md text-sm", withTabs && "rounded-tl-none mt-0"),
                        style: style,
                        children: [
                            filename ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block mb-2 text-gray-400",
                                children: filename
                            }) : null,
                            tokens.map((line, i)=>{
                                const lineProps = getLineProps({
                                    line,
                                    key: i
                                });
                                if (highlightedLines && highlightedLines.includes(i + 1)) {
                                    lineProps.style = {
                                        ...lineProps.style,
                                        backgroundColor: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"
                                    };
                                }
                                return withLineNumbers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WithLineNumbers, {
                                    index: i,
                                    lineProps: lineProps,
                                    children: line.map((token, key)=>{
                                        if (token.content !== "" || !token.empty) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ...getTokenProps({
                                                    token,
                                                    key
                                                })
                                            }, "token".concat(key));
                                        }
                                    })
                                }, "line".concat(i)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    pl: 2,
                                    ...lineProps,
                                    children: line.map((token, key)=>{
                                        if (token.content !== "" || !token.empty) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ...getTokenProps({
                                                    token,
                                                    key
                                                })
                                            }, "token".concat(key));
                                        }
                                    })
                                }, "line".concat(i));
                            })
                        ]
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 35182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ normalizeString; }
/* harmony export */ });
const normalizeString = {
    toKebabCase: (string)=>{
        var ref;
        return (ref = string.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || ref === void 0 ? void 0 : ref.map((x)=>x.toLowerCase()).join("-");
    }
};


/***/ })

}]);